import { DatalayerHelper } from './ib-datalayer-helper';
import * as ancillariesInfo   from '../core/models/ancillaries-info';
import isEqual from 'lodash-es/isEqual.js';
import omit from 'lodash-es/omit.js';

@Service('ib-web-ancillaries-module',
    ['CommonsUtilService', 'DatalayerHelper', 'localStorageService', 'DatalayerUtilsService', 'AncillariesConstants'],
    ['ib-commons-constants-module', 'ib-monetate-module'])
export class SpeqsDatalayerUtils {
    seatSelectedId: string[] = [];
    seatSelectedType: string[] = [];
    segmentId: string;
    constructor (
        private CommonsUtilService: CommonsUtilService,
        private DatalayerHelper: DatalayerHelper,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private AncillariesConstants: AncillariesConstant
    ) { }

    getDataEcommerceForSpecialBaggage (ancillaryType, slice, piece) {
        const itemCategory2: string = this.DatalayerUtilsService.getItemCategory2(slice);
        const id = this.CommonsUtilService.getIdItem('all');
        let item: DigitalDataEcommerceModel.Item = {
            item_name: ancillaryType,
            item_id: id,
            price: piece?.availablePriceRanges[0]?.amount,
            item_brand: this.DatalayerHelper.getBrandItem(slice?.id, slice?.id),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: itemCategory2,
            item_category3: this.DatalayerUtilsService.getItemCategory3(ancillaryType, itemCategory2, id),
            item_variant: this.getSpeqsVariant(piece),
            quantity: slice?.passengers.length
        };
        item = this.DatalayerHelper.ecommerceFlowCKI(item, slice);
        return item;
    }

    getSpeqsVariant = (piece: any): string => {
        switch (piece?.subtype) {
                case this.AncillariesConstants.SPEQS_SUBTYPE.SKI_SNOW: return this.AncillariesConstants.DATALAYER_INFO.SKI_SNOW;
                case this.AncillariesConstants.SPEQS_SUBTYPE.BICYCLE: return this.AncillariesConstants.DATALAYER_INFO.BICYCLE;
                case this.AncillariesConstants.SPEQS_SUBTYPE.GOLF_EQUIPMENT: return this.AncillariesConstants.DATALAYER_INFO.GOLF_EQUIPMENT;
                case this.AncillariesConstants.SPEQS_SUBTYPE.FISHING_EQUIPMENT: return this.AncillariesConstants.DATALAYER_INFO.FISHING_EQUIPMENT;
                case this.AncillariesConstants.SPEQS_SUBTYPE.SCUBA_DIVING: return this.AncillariesConstants.DATALAYER_INFO.SCUBA_DIVING;
                case this.AncillariesConstants.SPEQS_SUBTYPE.SURFBOARD: return this.AncillariesConstants.DATALAYER_INFO.SURFBOARD;
                case this.AncillariesConstants.SPEQS_SUBTYPE.SPORTING_FIREARMS: return this.AncillariesConstants.DATALAYER_INFO.SPORTING_FIREARMS;
                default: return '';
        }
    };

    getItemCategory2 = (trip) => trip.departure.code + '-' + trip.arrival.code;
    getSpeqsQuantity = (piece) => Number(piece.quantySelected);
    setSpeqsSelectItem = (trip: any, piece: any): DigitalDataEcommerceModel.ViewItemList => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const id: string = this.CommonsUtilService.getIdItem('all');
        const itemCategory2: string = this.getItemCategory2(trip);
        let item: DigitalDataEcommerceModel.Item = {
            item_name: 'special baggage',
            item_id: id,
            price: this.DatalayerHelper.getBaggagePrice(piece),
            item_brand: this.DatalayerHelper.getBrandItem(trip?.departure?.code, trip?.id),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: itemCategory2,
            item_category3: this.DatalayerUtilsService.getItemCategory3('special baggage', itemCategory2, id),
            item_variant: this.getSpeqsVariant(piece),
            quantity: this.getSpeqsQuantity(piece)
        };
        item = this.DatalayerHelper.ecommerceFlowCKI(item, trip.id, piece);
        digital_data_ecommerce.items.push(item);
        return digital_data_ecommerce;
    };

    setSpeqsEventCart = (model: any) => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        let itemsToAdd: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        let itemsToRemove: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const addToCart: DigitalDataEcommerceModel.ViewItemList = this.DatalayerHelper.getItemAddToCartByItemName('special baggage');
        const id = this.CommonsUtilService.getIdItem();
        model?.passengers.forEach(passenger => {
            passenger?.trips.forEach(trip => {
                const itemCategory2: string = trip.departure.code + '-' + trip.arrival.code;
                trip.pieces.forEach(piece => {
                    if (piece.quantySelected > 0) {
                        let item: DigitalDataEcommerceModel.Item = {
                            item_name: 'special baggage',
                            item_id: id,
                            price: this.DatalayerHelper.getBaggagePrice(piece),
                            item_brand: this.DatalayerHelper.getBrandItem(trip?.departure?.code, trip?.id),
                            item_category: this.DatalayerHelper.getItemCategory(),
                            item_category2: itemCategory2,
                            item_category3: model.passengers[0].trips.findIndex((tripFromModel) => tripFromModel.id === trip.id) + 1,
                            item_variant: this.getSpeqsVariant(piece),
                            quantity: Number(piece.quantySelected)
                        };
                        item = this.DatalayerHelper.ecommerceFlowCKI(item, trip);
                        const indexAddToCart = digital_data_ecommerce.items.findIndex(itemAddToCart => isEqual(omit(item, ['quantity']), omit(itemAddToCart, ['quantity'])));
                        if (indexAddToCart < 0) {
                            digital_data_ecommerce.items.push(JSON.parse(JSON.stringify(item)));
                        } else {
                            digital_data_ecommerce.items[indexAddToCart].quantity = digital_data_ecommerce.items[indexAddToCart].quantity + item.quantity;
                        }

                    }
                });
            });
        });
        itemsToAdd = this.DatalayerHelper.getItemsToAddOrRemove(addToCart, digital_data_ecommerce, true);
        itemsToRemove = this.DatalayerHelper.getItemsToAddOrRemove(addToCart, digital_data_ecommerce, false);
        return {itemsToAdd, itemsToRemove};
    };
}

